module.exports = __webpack_public_path__ + "static/media/scanner-image.f556fa0a.svg";